/*
  Carrinho da Hogo: um dropdown pendurado na navbar, irmao do painel do menu.

  Continua se chamando cart-drawer porque o resto do tema procura por esse nome:
  product-form.js pega document.querySelector('cart-drawer') para abrir o
  carrinho depois do "add to cart", e cart.js usa os IDs CartDrawer-*. O que
  muda aqui e so o jeito de abrir — nada de gaveta em cima da tela.

  A conversa com o menu acontece por eventos no document (hogo:cart:open /
  hogo:menu:open) para os dois arquivos nao dependerem da ordem de carregamento.
*/

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('.custom-header');
    this.setHeaderCartIconAccessibility();

    document.addEventListener('hogo:menu:open', () => this.close());

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.isOpen()) return;
      this.close();
      if (this.cartLink) this.cartLink.focus();
    });

    // O painel vive dentro do header, entao qualquer clique fora dele fecha.
    document.addEventListener('click', (event) => {
      if (!this.isOpen()) return;
      if (event.target.closest('.custom-header__panel')) return;
      if (event.target.closest('.cart-panel')) return;
      if (event.target.closest('#cart-icon-bubble')) return;
      this.close();
    });

    document.querySelectorAll('.js-menu-close').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });
  }

  get cartLink() {
    return document.querySelector('#cart-icon-bubble');
  }

  isOpen() {
    return this.classList.contains('is-open');
  }

  isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = this.cartLink;
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-expanded', 'false');
    cartLink.setAttribute('aria-controls', 'CartDrawer');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.isOpen() ? this.close() : this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.isOpen() ? this.close() : this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    document.dispatchEvent(new CustomEvent('hogo:cart:open'));

    this.classList.add('is-open');
    if (this.header) this.header.classList.add('cart-is-open');
    if (this.cartLink) this.cartLink.setAttribute('aria-expanded', 'true');

    // No desktop o painel tem 328px e a pagina continua navegavel por tras.
    if (this.isMobile()) document.body.style.overflow = 'hidden';
  }

  close() {
    if (!this.isOpen()) return;

    this.classList.remove('is-open');
    if (this.header) this.header.classList.remove('cart-is-open');
    if (this.cartLink) this.cartLink.setAttribute('aria-expanded', 'false');

    // O cart.js prende o foco no painel depois de mudar a quantidade; solta.
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);

    // O menu pode estar aberto: so libera a rolagem se ninguem mais precisar.
    if (!this.header || !this.header.classList.contains('menu-is-open')) {
      document.body.style.overflow = '';
    }
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => this.open());
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  // O cart.js procura o input pelo id da pagina /cart (#Quantity-N). No painel
  // ele se chama #Drawer-quantity-N, e sem este ajuste a validacao de
  // quantidade (passar do estoque, por exemplo) estourava no console.
  resetQuantityInput(id) {
    const input = this.querySelector(`#Drawer-quantity-${id}`);
    if (!input) return;

    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  // Idem para a atualizacao vinda de fora (outra aba, app): o cart.js troca
  // pedacos com os nomes do Dawn. Aqui basta redesenhar o corpo do painel.
  onCartUpdate() {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('.cart-panel__body');
        const target = document.querySelector('.cart-panel__body');
        if (!source || !target) return;

        target.innerHTML = source.innerHTML;

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.classList.toggle('is-empty', !html.querySelector('.cart-panel__item'));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        // A troca cobre a lista, o subtotal e o botao de checkout de uma vez:
        // remover o ultimo item precisa trazer o estado vazio junto.
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-panel__body',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
